export const mobileNav = () => {
  window.mobileNav = function ($el) {
    return {
      collapsing: false,
      expanded: false,
      transitioning: false,

      toggle () {
          this.expanded ? this.collapse() : this.expand();
      },

      expand () {
          if (this.collapsing || this.expanded) {
              return;
          }

          this.expanded = true;
          this.collapsing = true;

          let $list = this.$refs.list;

          $list.classList.add('collapsing');
          $list.style.height = 0;
          $list.setAttribute('aria-expanded', 'true');

          this.transitioning = true;

          const complete = () => {
              this.transitioning = false
              this.collapsing = false;
              $list.style.height = '';
              $list.classList.remove('collapsing');
              $list.removeEventListener('transitionend', complete);
          }

          $list.addEventListener('transitionend', complete);
          $list.style.height = `${$list.scrollHeight}px`;
      },

      collapse () {
          if (this.collapsing || !this.expanded) {
              return;
          }

          this.collapsing = true;
          this.expanded = false;

          let $list = this.$refs.list;

          $list.style.height = `${$list.getBoundingClientRect().height}px`;
          $list.offsetHeight;
          $list.setAttribute('aria-expanded', 'false');

          $list.classList.add('collapsing');

          const complete = () => {
              this.transitioning = false
              this.collapsing = false;
              $list.classList.remove('collapsing');
              $list.removeEventListener('transitionend', complete);
          }

          $list.style.height = 0;
          $list.addEventListener('transitionend', complete);
      }
    }
  };
}
